import { jsx as _jsx } from "react/jsx-runtime";
import { useRetrieveLeague } from "../api/LeagueApiProvider";
import { useDeactivateVenueFromLeague, useListLeagueHomeVenues, useRemoveVenueFromLeague, } from "../api/LeagueVenueApiProvider";
import { useRetrieveUserLeaguePermissions } from "../api/PermissionApiProvider";
import { ErrorView } from "../nav/Error";
import { Forbidden } from "../nav/Forbidden";
import { Loading } from "../nav/Loading";
import { NotFound } from "../nav/NotFound";
import { useNumericParams } from "../utils/useNumericParams";
import { ManageVenueAssociations } from "../venues/ManageVenueAssociations";
export var ManageLeagueVenues = function () {
    var id = useNumericParams().id;
    var _a = useRetrieveLeague({ id: id }), league = _a.data, isLoading = _a.isLoading, error = _a.error;
    var _b = useRetrieveUserLeaguePermissions({
        leagueId: id,
    }), permissions = _b.data, isPermsLoading = _b.isLoading, permsError = _b.error;
    var _c = permissions || {}, _d = _c.canView, canView = _d === void 0 ? false : _d, _e = _c.canModify, canModify = _e === void 0 ? false : _e;
    var _f = useListLeagueHomeVenues({ leagueId: id, enabled: canView }), venues = _f.data, isVenuesLoading = _f.isLoading, venuesError = _f.error;
    var deactivateMutation = useDeactivateVenueFromLeague({
        leagueId: id,
        onSuccess: function () { },
        onError: function () { },
    });
    var removeMutation = useRemoveVenueFromLeague({
        leagueId: id,
        onSuccess: function () { },
        onError: function () { },
    });
    var handleDeactivate = function (venueAssociationId, toDate) {
        deactivateMutation.mutate({
            leagueVenueId: venueAssociationId,
            toDate: toDate,
        });
    };
    var handleRemove = function (venueAssociationId) {
        removeMutation.mutate(venueAssociationId);
    };
    if (!id) {
        return _jsx(NotFound, {});
    }
    if (isLoading || isPermsLoading || isVenuesLoading) {
        return _jsx(Loading, {});
    }
    if (!canModify) {
        return _jsx(Forbidden, {});
    }
    if (error || !league || permsError || venuesError) {
        return (_jsx(ErrorView, { error: error ||
                permsError ||
                venuesError ||
                new Error("Failed to load league or venues.") }));
    }
    return (_jsx(ManageVenueAssociations, { entityName: "league", entityDisplayName: league.name, entityId: id, venues: venues || [], addVenueUrl: "/leagues/".concat(id, "/venues/add/"), deactivateMutation: deactivateMutation, removeMutation: removeMutation, onDeactivate: handleDeactivate, onRemove: handleRemove }));
};
